import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './tailwind.css'
import App from './App.jsx'
import ScrollToTop from "@/lib/ScrollToTop";

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <ScrollToTop />
        <App />
    </StrictMode>
)
